/**
 * Created by hj on 2017/8/31.
 */
import {config, request} from 'Utils';

/**
 * 首页轮播图设置 查询
 * @param param
 * @returns {*}
 */
export function check(param) {
  return request(`${config.server}/api/v1/dms/index/images/list`, {
    method: 'post',
    body: param
  });
}

/**
 * 首页轮播图设置 保存
 * @param param
 * @returns {*}
 */
export function save(param) {
  return request(`${config.server}/api/v1/dms/index/images/save`,{
    method: 'post',
    body: param
  });
}

/**
 * 委托书模版 查询
 * @param param
 * @returns {*}
 */
export function checkEntrust() {
  return request(`${config.server}/api/v1/dms/invoice/getProxyTemplate`,{
    method: 'get'
  });
}

/**
 * 委托书模版 保存
 * @param param
 * @returns {*}
 */
export function saveEntrust(temlateId) {
  return request(`${config.server}/api/v1/dms/invoice/setProxyTemplate?temlateId=${temlateId}`,{
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/service/homeSet/index.js